import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Label,
} from "reactstrap";
import {
  CREATE_TRIVVY_MODAL_IMAGES,
  CUSTOM_QUESTION_INPUT_TYPES,
  MAX_OPTIONS_ARRAY,
  MIN_OPTIONS_ARRAY,
  WEB_GENERATE_ERROR_MESSAGE,
} from "../../data";
import Select from "react-select";
import QuizTextEditor from "../../../../components/QuizTextEditor/QuizTextEditor";
import { BiXCircle } from "react-icons/bi";
import { isMobile } from "../../../../utils/deviceInfo";
import RangeInput from "../../../../components/RangeInput/RangeInput";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import ReactTooltip from "react-tooltip";
import LibQuestionFormFields from "./LibQuestionFormFields";
import { toastContainer } from "../../../../utils/toast";
import {
  BsHandThumbsDown,
  BsHandThumbsDownFill,
  BsHandThumbsUp,
  BsHandThumbsUpFill,
} from "react-icons/bs";

const question_count_options = Array(20)
  .fill()
  .map((_, index) => ({ label: index + 1, value: index + 1 }));

export default function LibraryQuestionEditModal({
  open,
  onClose,
  questionObject,
  onEditSuccess,
}) {
  const [questionData, setQuestionData] = useState({
    questionType: "MCQ",
    text: "",
    options: ["Option 1"],
    correctOption: "",
    linearNumericConfigs: { min: 1, max: 10 },
    rating: null,
  });

  useEffect(() => {
    setQuestionData({
      questionType: questionObject.questionType,
      text: questionObject.questionText,
      options: questionObject.options,
      correctOption: questionObject.answer,
      linearNumericConfigs: questionObject.linearNumericConfigs,
      rating: questionObject.rating,
    });
  }, []);

  const handleEditQuestions = () => {
    const {
      questionType,
      text,
      options,
      correctOption,
      linearNumericConfigs,
      rating,
    } = questionData;

    const payload = {
      questionId: questionObject._id,
      question_text: text,
      options: options,
      answer: correctOption,
      linearNumericConfigs: linearNumericConfigs,
      rating,
    };

    axios
      .post(url.editLibraryQuestion, payload)
      .then(({ data }) => {
        onEditSuccess(data.data);
      })
      .catch((error) => {
        let errorMsg = WEB_GENERATE_ERROR_MESSAGE.replace(
          "trivvy",
          "questions"
        );
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          errorMsg = error.response.data.errors.message;
        }

        toastContainer(errorMsg, "error");
      });
  };

  const noFieldChange = () => {

    if(questionData.text){
      let bool = true

      if(questionData.text != questionObject.questionText){
        console.log("AAA")
        bool = false
      }
      if(questionObject.questionType == "MCQ"){
        if(JSON.stringify(questionData.options) != JSON.stringify(questionObject.options) ){
          console.log("BBB")
          bool = false
        }
        if(questionData.correctOption != questionObject.answer){
          console.log("CCC")
          bool = false
        }
      }
      
      if(questionData.rating != questionObject.rating){
        console.log("DDD")
        bool = false
      }
  
      console.log({bool})
  
      return bool
    }

    return true;
   

 
   
  };

  return (
    <Modal isOpen={open}>
      <ModalHeader toggle={onClose} className="trivia_modal_header_bg">
        Edit question
      </ModalHeader>
      <ModalBody className="p-4">
        <div>
          <LibQuestionFormFields
            questionData={questionData}
            setQuestionData={setQuestionData}
          />

          <div className="my-3">
            <div className="cursor-pointer d-flex pl-3 align-items-center">
              Rate this Question:
              <span>
                {questionData.rating === 1 ? (
                  <BsHandThumbsUpFill
                    size={18}
                    className="ml-1"
                    color="#ff4500"
                  />
                ) : (
                  <BsHandThumbsUp
                    onClick={() => {
                      setQuestionData({
                        ...questionData,
                        rating: 1,
                      });
                    }}
                    size={18}
                    className="ml-1"
                    color="#ff4500"
                  />
                )}
                {questionData.rating === 0 ? (
                  <BsHandThumbsDownFill
                    size={18}
                    className="ml-2"
                    color="#ff4500"
                  />
                ) : (
                  <BsHandThumbsDown
                    onClick={() => {
                      setQuestionData({
                        ...questionData,
                        rating: 0,
                      });
                    }}
                    size={18}
                    className="ml-2"
                    color="#ff4500"
                  />
                )}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <Button
            className="float-right trivia-action-button-main"
            onClick={() => handleEditQuestions()}
            style={{
              height: "37px",
            }}
            disabled={noFieldChange()}
          >
            Save changes
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
